var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__main is-offset container"})
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./Scripts/Components/HelpDocumentsInfo.vue